import store from "@/store"
import router from "@/router"
/*
 * Function to convert a product on Cherrytree to the way that GA and GTM want it for enhanced ecommerce
 * @param product is the product to unwrap for GA and GTM
 * @param quantity is the number of product being added to cart or purchased
 */
export const makeProductObject = (product, quantity, preDefCat) => {
	let category = "";
	if (!preDefCat) {
		const cats = store.getters["reference/categoriesMap"]
		const cat = router.currentRoute.query.category || null
		const subcat = router.currentRoute.query.subcategory || null
		if(cat && subcat) {
			category = cats[cat].category + "/" + cats[subcat].category
		}
	} else {
		category = preDefCat
	}
	if (quantity) {
		return {
			id: product.id,
			name: product.title,
			price: product.prices.member_price.price,
			brand: product.brand,
			category,
			quantity
		}
	}
	return {
		id: product.id,
		name: product.title,
		price: product.prices.member_price.price,
		brand: product.brand,
		category
	}
} 